import React, { useEffect, useState, useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Form } from 'antd'
import PasswordChecklistIndicator from 'components/design/Form/PasswordChecklist'
import _ from 'lodash'
import ButtonBlack from 'components/design/Form/ButtonBlack'
import FormInput from '../../design/Form/Input'
import FormInputPhone from '../../design/Form/InputPhone'
import style from '../../../layouts/Auth/style.module.scss'
import formStyle from './style.module.scss'

const WelcomeForm = ({
  footer,
  nextStep,
  form,
  password,
  setPassword,
  name,
  setName,
  setIsPasswordValid,
  isPasswordValid,
  setUserContactNumber,
  userContactNumber,
  userCountryCode,
  setUserCountryCode,
}) => {
  const [isPasswordFocused, setIsPasswordFocused] = useState(false)
  const [displayCustomValidError, setDisplayCustomValidError] = useState(false)
  const user = useSelector(state => state.user)
  const [checkForCustomerContext, setCheckForCustomerContext] = useState(false)
  const dispatch = useDispatch()

  const updateUserCountryCode = useCallback(
    ({ error, cancelled, data }) => {
      if (!error && !cancelled && data.data) {
        if (user.customerContext !== undefined && user.customerContext.geoip_country) {
          setUserCountryCode(_.lowerCase(user.customerContext.geoip_country))
        }
        setCheckForCustomerContext(true)
      }
    },
    [setUserCountryCode, user.customerContext],
  )

  const dispatchCustomerContext = useCallback(() => {
    dispatch({
      type: 'user/GET_CUSTOMER_CONTEXT',
      onComplete: updateUserCountryCode,
    })
  }, [dispatch, updateUserCountryCode])

  useEffect(() => {
    if (!checkForCustomerContext) {
      dispatchCustomerContext()
    }
  }, [checkForCustomerContext, dispatchCustomerContext, user.customerContext])

  const handleNameInput = e => {
    setName({ name: e.target.value })
  }

  const onFocusHandler = () => {
    if (document.activeElement.id === 'password') setIsPasswordFocused(true)
  }

  const onBlurHandler = () => {
    setIsPasswordFocused(false)
  }

  const handlePhoneNumberChange = (phone, data) => {
    setUserContactNumber(phone)
    setUserCountryCode(data.countryCode)
  }

  const handleContinue = async () => {
    try {
      const fieldsToValidate = ['name', 'password']
      await form.validateFields(fieldsToValidate)
      if (!isPasswordValid) {
        setDisplayCustomValidError(true)
        throw new Error('Password does not meet requirements.')
      } else {
        setDisplayCustomValidError(false)
      }

      nextStep()
    } catch (err) {
      console.log('Validation failed:', err)
    }
  }

  return (
    <div className={formStyle.cometchatOnboardingContainer}>
      <div className={formStyle.cometchatOnboarding}>
        <div className={formStyle.cometchatOnboardingForm}>
          <div className={formStyle.cometchatOnboardingHeader}>
            <div className={formStyle.welcomeHeaderTitle}>Welcome to CometChat!</div>
            <div className={formStyle.welcomeHeaderSubtitle}>
              Let&apos;s start by creating your account
            </div>
          </div>

          <div className={style.formWrapper} style={{ width: '100%' }}>
            <FormInput
              autoFocus
              Form={Form}
              name="prefilledEmail"
              label={<div className={formStyle.cometchatWelcomeInputLabel}>Email</div>}
              style={{ height: '44px', borderColor: '#d5d7da' }}
              placeholder="Enter your email address"
              disabled
            />
            <FormInput
              onChange={handleNameInput}
              Form={Form}
              label={<div className={formStyle.cometchatWelcomeInputLabel}>Name</div>}
              style={{ height: '44px', borderColor: '#d5d7da' }}
              name="name"
              value={name}
              placeholder="Enter your full name"
              rules={[{ required: true, message: 'Please enter your name' }]}
            />

            <div className={style.passwordInputWrapper}>
              <FormInput
                onChange={e => {
                  setDisplayCustomValidError(false)
                  setPassword(e.target.value)
                }}
                Form={Form}
                label={<div className={formStyle.cometchatWelcomeInputLabel}>Password</div>}
                style={{ height: '44px', borderColor: '#d5d7da' }}
                name="password"
                value={password}
                placeholder="Create your password"
                rules={[{ required: true, message: 'Please enter your password' }]}
                type="password"
                formItemStyles={{ marginBottom: '12px' }}
                onFocusHandler={() => onFocusHandler()}
                onBlurHandler={() => onBlurHandler()}
                autoFocus={false}
                customFormError={
                  displayCustomValidError && 'Password must meet all the requirements.'
                }
              />

              <PasswordChecklistIndicator
                isPasswordFocused={isPasswordFocused}
                value={password}
                onChange={isValid => {
                  setIsPasswordValid(isValid)
                }}
                customStyles={{ marginTop: '-4px' }}
              />
              {!isPasswordFocused && <div style={{ height: '4px' }} />}
            </div>

            <FormInputPhone
              userCountryCode={userCountryCode}
              userContactNumber={userContactNumber}
              handlePhoneNumberChange={handlePhoneNumberChange}
              name="contactNumber"
              Form={Form}
              label={
                <span style={{ font: '500 14px Satoshi', color: '#414651' }}>
                  Phone No <span className={style.optionalIndicator}>(Optional)</span>
                </span>
              }
              inputStyle={{ height: '44px', borderColor: '#d5d7da' }}
            />
            <ButtonBlack
              buttonStyles={{
                width: '100%',
                height: '44px',
                margin: '24px 0px',
                fontSize: '16px',
              }}
              buttonText="Continue"
              loading={user.loading}
              onClick={handleContinue}
            />
          </div>
          {footer}
        </div>
      </div>
    </div>
  )
}

export default WelcomeForm
